import React, { FC } from 'react';
import LoadingWheel from '../../atoms/LoadingWheel';
import Typography from '../../atoms/Typography';
import styles from './CustomLoader.module.css';

export interface CustomLoaderProps {
  /**
   * Text to display next to the loading spinner
   * @default 'Loading ...'
   */
  text?: string;
  /**
   * Size of the loading wheel
   * @default 24
   */
  size?: number;
  /**
   * Additional class name for custom styling
   */
  className?: string;
}

/**
 * CustomLoader - A molecule component displaying a loading spinner with text
 * Used in Content Rule Center for various loading states
 */
const CustomLoader: FC<CustomLoaderProps> = ({
  text = 'Loading ...',
  size = 24,
  className = '',
}) => {
  return (
    <div className={`${styles.customLoader} ${className}`}>
      <LoadingWheel size={size} />
      <Typography variant='text-md' className={styles.loadingText}>
        {text}
      </Typography>
    </div>
  );
};

CustomLoader.displayName = 'CustomLoader';

export default CustomLoader;
